import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './title-box.module.less';

export const TitleBox = ({ className = '', renderTitle, renderBody }) => (
  <div className={classnames(className, style['title-box'])}>
    <div className={style['title-box-title']}>{renderTitle()}</div>
    <div className={style['title-box-body']}>{renderBody()}</div>
  </div>
);

TitleBox.propTypes = {
  renderTitle: PropTypes.func.isRequired,
  renderBody: PropTypes.func.isRequired,
  className: PropTypes.string,
};
